import EnErrorCodes from '../en/legalEntity';

const LegalEntityErrorCodes: Record<keyof typeof EnErrorCodes, string> = {
  LET00001: 'entidade legal não encontrada',
} as const;

export default LegalEntityErrorCodes;
